import { ProjetoService } from 'src/app/projeto/projeto.service';
import { Component, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { NgbModal, NgbModalRef  } from '@ng-bootstrap/ng-bootstrap';
@Component({
	selector: 'app-form-projeto-stakeholder',
  	templateUrl: './form-projeto-stakeholder.component.html',
  	styleUrls: ['./form-projeto-stakeholder.component.scss']
})
export class FormProjetoStakeholderComponent{
	@ViewChild('Swal') public swal:SwalComponent;
	@ViewChild('SwalDelete') public swalDelete:SwalComponent; 
	@Input() projetosStakeholders = new Array();
	@Input() detalhe: boolean;
	@Input() pessoa_id: number;
	@Input() acao:string;
	create:boolean;
	edit:boolean;
	detail:boolean;
	delete:boolean;
	modalDetalhe:boolean = false;
	form: FormGroup;
	projeto_stakeholder_id:number = null;
	modalTitle:string;
	submitted: boolean = false;
	loading: boolean = false;
	modalReference: NgbModalRef; 
	constructor(private projetoService: ProjetoService, private formBuilder: FormBuilder, private modalService: NgbModal, private activatedRoute: ActivatedRoute){
        this.form = this.formBuilder.group({
			nome: this.formBuilder.control('',[Validators.required]),
			instituicao: this.formBuilder.control(''),
			funcao: this.formBuilder.control('',[Validators.required]),
			telefone: this.formBuilder.control('',[Validators.required]),
			email: this.formBuilder.control('',[Validators.email]),
			observacao: this.formBuilder.control(''),
		})
	}

	ngOnInit(){ 
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(t.permissao.projeto_stakeholder.includes("CONSULTAR"))
			this.detail = true;
		if(t.permissao.projeto_stakeholder.includes("CRIAR"))
			this.create = true;
		if(t.permissao.projeto_stakeholder.includes("EDITAR"))
			this.edit = true;
		if(t.permissao.projeto_stakeholder.includes("EXCLUIR"))
			this.delete = true;
	}
	
	onSubmit(){
		this.submitted = true;
        if(!this.form.valid)
		return;
		this.modalReference.close();
		if(!this.projeto_stakeholder_id){
			this.projetoService.addProjetoStakeholder(this.activatedRoute.snapshot.params['id'], this.form)
			.subscribe( (success) => {
				this.swal.text = "Stakeholder cadastrado com sucesso!";
				this.swal.type = "success";
				this.swal.title = "Pronto!";
				this.swal.show();
				this.submitted = false;
				this.zeraForm();
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
			});
			return;
		}

		this.projetoService.editProjetoStakeholder(this.projeto_stakeholder_id,this.form)
			.subscribe( (success) => {
				this.swal.text = "Stakeholder atualizado com sucesso!";
				this.swal.type = "success";
				this.swal.title = "Pronto!";
				this.swal.show();
				this.submitted = false;
				this.zeraForm();
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
				this.zeraForm();
			});

		
	}
	zeraForm():void{
		this.form.patchValue({
			nome: '',
			instituicao: '',
			funcao: '',
			telefone: '',
			email: '',
			observacao: '',
		});
	}

	openModal(modal,id:number = null,detalhe:boolean = false) {
		this.modalDetalhe = detalhe;
		//Se id == null então é cadastro.
		if(!id){
			this.projeto_stakeholder_id = null;
			this.modalTitle = "Cadastrar Stakeholder";
			this.modalReference = this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
			return;
		}
		
		//Senão é edição.
		this.projeto_stakeholder_id = id;
		this.modalTitle = "Editar Stakeholder";
		this.projetoService.getProjetoStakeholderById(id).subscribe((success) => {
			this.form.patchValue({
				nome: success.dados.nome,
				instituicao: success.dados.instituicao,
				funcao: success.dados.funcao,
				telefone: success.dados.telefone,
				email: success.dados.email,
				observacao: success.dados.observacao,
			});
			this.modalReference = this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
		})
	}

	askDelete(id:number){
		this.projeto_stakeholder_id = id;
		this.swalDelete.show();
	}

	confirmDelete(){
		this.projetoService.delProjetoStakeholder(this.projeto_stakeholder_id).subscribe( 
		(success) => {
			this.swal.text = "Stakeholder deletado com sucesso!";
			this.swal.type = "success";
			this.swal.title = "Pronto!";
			this.swal.show();
			this.submitted = false;
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
			this.submitted = false;
		});
	}

	onCloseModal(){
		if(this.swal.type == "success"){
			this.projetoService.getProjetoById(this.activatedRoute.snapshot.params['id']).subscribe((success)=>{
				this.projetosStakeholders = success.dados.stakeholder;
				this.submitted = false;
			},
			(error) => {
				this.swal.text = error.error.message;
				this.swal.type = "error";
				this.swal.title = "Erro!";
				this.swal.show();
				this.submitted = false;
			});
		}
	}
}